import { makeStyles, Theme } from '@material-ui/core/styles';

import { SIZE } from '../../constants';

const getSpacing = (height: number | string, theme: Theme) => {
  switch (height) {
    case SIZE.small:
      return theme.spacing(0, 2);
    case SIZE.medium:
      return theme.spacing(0, 3);
    default:
      return 0;
  }
};

export interface Props {
  height: number | string;
  isLink: boolean;
  noPadding: boolean;
}

const useStyles = makeStyles<Theme, Props>(theme => ({
  menuItem: {
    '& a': {
      color: 'inherit',
      flex: 1,
      padding: props => getSpacing(props.height, theme),
      textAlign: 'left',
      textDecoration: 'none',
    },
    '&:hover': {
      backgroundColor: theme.palette.common.gray100,
    },

    height: props => props.height,

    padding: props => (props.isLink || props.noPadding ? 0 : getSpacing(props.height, theme)),
  },
}));

export default useStyles;
